import { i18nModule } from "@config/i18n.module";
import { ResourcesModule } from "@resources/resources.module";
import { UtilsModule } from "@utils/utils.module";
import { NgModule } from "@angular/core";
import { DynamicComponentModule } from "ng-dynamic";
import {VosFiltresComponent} from "app/common/components/vos-filtres/vos-filtres.component";
import { PDFService } from '@common/services/pdf.service';

var modulesImport: Array<any> = [
  /** Liste des modules */
  UtilsModule,
  ResourcesModule,
  i18nModule,
  DynamicComponentModule.forRoot({
    imports: [UtilsModule, i18nModule]
  })
];

var modulesExport: Array<any> = [
  /** Liste des modules */
  UtilsModule,
  ResourcesModule,
  i18nModule,
  DynamicComponentModule,
  VosFiltresComponent
];


@NgModule({
  declarations: [
    VosFiltresComponent
  ],
  imports: modulesImport,
  exports: modulesExport,
  providers: [
    PDFService
  ]
})
export class CerbaCommonModule {



}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-formulaire-demat/digicerba-formulaire-demat-web/src/angular/cerba/src/app/common/cerba-common.module.ts